import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import PagesCreateEditForm from './Components/PagesCreateEditForm';
import PagesApi from './PagesApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: PagesCreateEditForm,
                getCreate: PagesApi.create,
                getClone: PagesApi.getOne,
                defaults: {
                    contentBlocks: []
                },
                successMessage: "Page Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}